import IncidentAgenciesAtAGlanceGraph from './IncidentAgenciesAtAGlanceGraph';

export default IncidentAgenciesAtAGlanceGraph;
